import { PlanTypes } from '@chiroup/core/types/HomePage.type';
import { UserRoles } from '@chiroup/core/types/User.type';

import { Icon } from '@chiroup/components/Icon';
import { Icons } from '@chiroup/components/icons';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { use, useMemo } from 'react';
import { MeContext } from '../../contexts/me.context';
import Announcement from './Announcement';

dayjs.extend(utc);

const EhrGracePeriodBanner = () => {
  const { me, hasRole } = use(MeContext);

  const graceEndDate = me?.selectedClinic?.ehrGracePeriodEndDate;

  const announcementText = useMemo(() => {
    if (!me?.selectedClinic?.ehr || me?.selectedClinic?.plan !== PlanTypes.ehr) return null;
    if (!graceEndDate) return null;
    if (!hasRole([UserRoles.Admin])) return null;

    return `We had trouble processing your payment. Please update your payment information at your earliest convenience. If you need help or have questions, reach out to us at support@chiroup.com. You will lose account access on ${dayjs.utc(graceEndDate).format('MMMM D, YYYY')} if unresolved.`;
  }, [me?.selectedClinic?.ehr, me?.selectedClinic?.plan, graceEndDate, hasRole]);

  if (!announcementText) return null;

  return (
    <Announcement
      text={announcementText}
      icon={<Icon icon={Icons.warningTriangle} className="h-6 w-6 text-white" />}
      error
    />
  );
};

export default EhrGracePeriodBanner;
